// Retry schedule of the outbox: exponential from two seconds, factor two,
// capped at five minutes, with jitter so a fleet of devices that lost the
// server at the same moment does not come back in one wave.

export const BACKOFF_BASE_MS = 2_000;
export const BACKOFF_FACTOR = 2;
export const BACKOFF_CAP_MS = 5 * 60_000;
/** Plus or minus this fraction. Kept under the factor's half so successive delays still grow. */
export const BACKOFF_JITTER = 0.2;

export function backoffDelayMs(
  consecutiveFailures: number,
  random: () => number = Math.random,
): number {
  const attempt = Math.max(1, Math.floor(consecutiveFailures));
  const base = Math.min(BACKOFF_CAP_MS, BACKOFF_BASE_MS * BACKOFF_FACTOR ** (attempt - 1));
  const jitter = 1 + (random() * 2 - 1) * BACKOFF_JITTER;
  return Math.round(base * jitter);
}
